import React, { useState } from "react";
import { Link } from "react-router-dom";

import { Collapse, Card, CardBody, Input, Label } from "reactstrap";

// swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";
import "swiper/css/effect-flip";
import { useTemplates } from "../../../../context/TemplatesContext";
import { getTemplateStatusStyle } from "../../../../types/template";

interface MoreMenuProps {
  isOpen: boolean;
  blockedMessage: string;
  onSelectTemplate: (templateId: string) => void;
}
const MoreMenuTemplates = ({
  isOpen,
  blockedMessage,
  onSelectTemplate,
}: MoreMenuProps) => {

  const { templates } = useTemplates();

  const isBlocked = blockedMessage && new Date(blockedMessage) > new Date();

  return (
    <Collapse
      isOpen={isOpen}
      className="chat-input-collapse"
      id="chatinputmorecollapse"
    >
      <Card className="mb-0">
        <CardBody className="py-3">

          <Swiper
            spaceBetween={20}
            slidesPerView={6}
            onSlideChange={() => ('slide change')}
            onSwiper={(swiper) => (swiper)}
          >

            {templates.map((t) => {
              const statusUI = getTemplateStatusStyle(t.status);

              return (
                <SwiperSlide key={t.id}>
                  <div
                    className="text-center px-2"
                    onClick={() => !isBlocked && onSelectTemplate(t.id)}
                  >
                    <div className="avatar-sm mx-auto">
                      <div
                        className={`avatar-title font-size-18 ${statusUI.bg} ${statusUI.text} rounded-circle`}
                      >
                        <i className="bx bx-file"></i>
                      </div>
                    </div>

                    <h5 className="font-size-11 text-uppercase mt-3 mb-0 text-body text-truncate d-none d-sm-block">
                      <Link to="#" className="text-body stretched-link">
                        {t.name}
                      </Link>
                    </h5>

                    {/* STATUS */}
                    {/* <small className={`${statusUI.labelClass} d-block mt-1`}>
                      {statusUI.label}
                    </small> */}

                    {/* CATEGORIA (opcional) */}
                    {t.status === "APPROVED" && (
                      <small className="text-muted d-block">
                        {t.category}
                      </small>
                    )}
                  </div>
                </SwiperSlide>
              );
            })}

          </Swiper>


        </CardBody>

      </Card>
    </Collapse>
  );
};

export default MoreMenuTemplates;
